import { useForm } from "react-hook-form";
import ModalUrlWindow from "../../components/modalUrl";
import api from "../../hooks/useApi"
import { redirect, useActionData, useLoaderData, useSubmit } from "react-router-dom";
import jsonToFormData from "../../hooks/jsonToFormData";
import { Autoform } from "../../components/forms/autoform";
import { Alert, Box } from "@mui/material";
import PageTitle from "../../components/PageTitle";

export async function action({ request, params }) {
    const formData = await request.formData();
    let response = {};
    try {
        response = await api.post('/api/HotelRates/', formData, {
            method: 'post',
            encType: 'multipart/form-data'
        })
        return redirect('/tariffs');
    } catch (e) {
        response = {
            status: e.response?.status || 'Unknown',
            message: e.message || 'An error occurred',
            data: e.response?.data || null,
        };
    }

    return null;
}

export async function loader({ request, params }) {
    const form = (await api.get('/api/CreateObjForms/HotelRates/')).data.form;
    //console.log(form);
    return form;
}

export default function NewTariff() {
    const formHook = useForm();
    const form = useLoaderData();
    const submit = useSubmit();
    const actionData = useActionData();

    const handleFormSubmit = (data) => {
        const formData = jsonToFormData(data);
        submit(formData, {
            method: 'post',
            encType: 'multipart/form-data'
        })
    }

    return (
        <ModalUrlWindow
            url='/tariffs'
            title={{ text: 'Додати новий тариф', variant: 'h5' }}
            width='md'
        >
            <PageTitle title="Новий тариф" />
            <Box sx={{ maxHeight: '80vh', overflow: 'auto', pt: 1 }}>
                <Autoform
                    formHook={formHook}
                    formName='HotelRates'
                    fields={form}
                    onSubmit={handleFormSubmit}
                />
                {actionData?.status && (
                    <Alert severity='error'>
                        Сталася помилка! {actionData.status}: {actionData.message}
                        
                    </Alert>
                )}
            </Box>
        </ModalUrlWindow>
    )
}
